// Design XML Update Types
// These types mirror the backend types from api/src/types/design_xml.py

export enum ChangeType {
  GRATING_ADDED = "grating_added",
  GRATING_REMOVED = "grating_removed",
  GRATING_UPDATED = "grating_updated",
  PAD_ADDED = "pad_added",
  PAD_REMOVED = "pad_removed",
  PAD_UPDATED = "pad_updated",
  PORT_COMBO_ADDED = "port_combo_added",
  PORT_COMBO_UPDATED = "port_combo_updated",
  PORT_COMBO_REMOVED = "port_combo_removed",
  STRUCTURE_ADDED = "structure_added",
  STRUCTURE_NAME_CHANGED = "structure_name_changed",
  STRUCTURE_REMOVED = "structure_removed",
}

export interface StructureChange {
  change_type: ChangeType;
  structure_id: string;
  structure_name: string;
  old_value?: any;
  new_value?: any;
  details?: Record<string, any>;
}

export interface DesignXMLDiff {
  has_breaking_changes: boolean;
  structures_added: string[];
  structures_removed: string[];
  structures_with_name_changes: Array<{ name: string; old_id: string; new_id: string }>;
  changes: StructureChange[];
  affected_mask_ids: string[];
}

export interface RemovedStructureInfo {
  id: string;
  name: string;
}

export interface NameChangedStructureInfo {
  old_id: string;
  new_id: string;
  name: string;
  changed_fields: string[];
}

export interface BreakingChangesDetail {
  message: string;
  structures_removed: RemovedStructureInfo[];
  structures_with_name_changes: NameChangedStructureInfo[];
}

export interface UploadDesignPreview {
  mask_id: string;
  mask_name: string;
  pcm_version: string;
  diff: DesignXMLDiff;
  requires_confirmation: boolean;
  message: string;
}

// Request types for API calls
export interface UpdateDesignRequest {
  mask_id: string;
  file: File;
  preview: boolean;
}
